import React from 'react'
import * as H from 'history'
import { Alert } from 'react-bootstrap'
import { ISupportSpinner } from '../../../shared/Ajax'
import {
  Checkbox, validateFields, ReadOnly, ReadLayout, TextField, NumericSelectField, FormItem,
} from '../../../shared/fields'
import { formatMoneyForDisplay, Salutation } from '../../../shared/Utility'
import { NextBackButtons } from '../../applicationForm-1/controls/NextBackButtons'
import { MilestoneReportModel } from '../../../models/MilestoneReportModel'
import { MilestoneModel } from '../../../models/MilestoneModel'
import { MilestoneReportController } from '../../../controllers/MilestoneReportController'
import { Backdrop } from '../../../shared/Backdrop'
import { MilestoneSubmission } from '../../../models/MilestoneSubmission'
import SupportingDocumentation from './Components/SupportingDocumentation'
import { MilestoneReportPreviewPage } from '../PreviewPage'
// import { Consultant } from '../../../models/Consultant'
// import { GrantAgreementDetailModel } from "../../../models/GrantAgreementDetailModel";
// import { Option } from '../../../shared/fields/Options'

export interface ReportFinalisationProps {
    history: H.History
    model: MilestoneReportModel
    preview?: boolean
    onSubmit: { (autoMilestoneReportIdentifier: string, callback?: { (): any }): any }
    onChange: { (changes: Partial<MilestoneModel>, callback?: { (): any }): any }
    // addressCountries: Option<string>[]
}

export interface ReportFinalisationState {
    loading: boolean
    pdfContent: boolean
    submissionError: string
}

export class ReportFinalisation extends React.Component<ReportFinalisationProps, ReportFinalisationState> implements
    ISupportSpinner {
  ajax: MilestoneReportController
  isDeclarationAccepted: Checkbox
  salutation: NumericSelectField
  authorisedFirstName: TextField
  authorisedLastName: TextField
  authorisedPosition: TextField
  previewContent: HTMLDivElement
  submittedErrorDiv: HTMLDivElement
  supportingDocumentation: SupportingDocumentation

  constructor(props: ReportFinalisationProps) {
    super(props)

    this.ajax = new MilestoneReportController()

    this.state = {
      loading: false,
      submissionError: '',
      pdfContent: false,
    }
  }

  submit = () => {
    const {
      model, history, onChange, onSubmit,
    } = this.props
    validateFields(
      (res) => {
        if (res) {
          if (confirm('You are about to submit the milestone report. Proceed?  \n\n You can\'t make any changes once you submit your milestone report.')) {
            this.setState({ pdfContent: true }, () => {
              const content = this.previewContent.innerHTML
              this.setState(
                { pdfContent: false },
                () => {
                  // Bug 131987 - Date is not shown in sql.
                  model.milestoneModel.dateMilestoneReportSubmitted = new Date()
                  const milestoneSubmission: MilestoneSubmission = { model: model.milestoneModel, content, grantAgreementDetailModel: model.grantAgreementDetailModel }
                  this.ajax.submit(
                    this,
                    milestoneSubmission,
                    (response) => {
                      if (response.errorMessage) {
                        this.setState({ submissionError: response.errorMessage })
                      } else {
                        onSubmit(response.autoMilestoneReportNumber, () => {
                          onChange({ milestoneIdentifier: response.autoMilestoneReportNumber })
                          history.push(`/milestone-report/${model.milestoneModel.milestoneReportID}/milestonesubmission`)
                        })
                      }
                    },
                  )
                },
              )
            })
          }
        }
      },
      this.isDeclarationAccepted,
      this.salutation,
      this.authorisedFirstName,
      this.authorisedLastName,
      this.authorisedPosition,
      this.supportingDocumentation,
    )
  }

  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }

  render() {
    const {
      model, onChange, history, preview, onSubmit,
      // , addressCountries
    } = this.props
    const { submissionError, loading, pdfContent } = this.state

    const salutationDataSource = [
      { value: Salutation.Mr, label: 'Mr' },
      { value: Salutation.Mrs, label: 'Mrs' },
      { value: Salutation.Ms, label: 'Ms' },
      { value: Salutation.Miss, label: 'Miss' },
      { value: Salutation.Other, label: 'Other' },
    ]

    return (
      <>
        <FormItem label={(
          <span className="form-content-preview" style={{ fontSize: this.props.preview ? '10pt' : 'inherits' }}>
            <h3>Report Finalisation</h3>
            <Alert className="emdg-page-alerts">
              Prior to submitting your milestone report it is important to review the information to confirm that you:
              <ul>
                <li style={{ marginTop: '0px' }}>
                  completed all the relevant fields and the information is accurate.
                </li>
                <li style={{ marginTop: '0px' }}>
                  requested a grant only for eligible expenses as per the EMDG Act and Rules.
                </li>
                <li style={{ marginTop: '0px' }}>
                  have excluded expenses and/or earnings that are subject to trade sanctions or that have a detrimental impact on Australia's trade reputation.
                </li>
                <li style={{ marginTop: '0px' }}>
                  can upload an invoice (or other supporting documentation) to substantiate the largest eligible expenditure item related to the Grant Activity during the Reporting Period as evidence.
                </li>
                <li style={{ marginTop: '0px' }}>
                  will be able to provide on request invoices, payment records and other supporting evidence of all eligible expenditure for which you are seeking grant funds and be able to explain how the expenses have been spent in accordance with the grant agreement.
                  Austrade may ask you for further information and documentation under Section 102 of the EMDG Act.
                </li>
              </ul>
            </Alert>
          </span>
)}
        />
        <br />
        <h3>Agreed Evidence</h3>

        <Alert className="emdg-page-alerts">
          <p>
            You, the Grantee, must provide an invoice (or other supporting documentation*) for the largest eligible expenditure item related to the Grant Activity during the Reporting Period as evidence.
          </p>
          <p>
            *If you don't have an invoice, other supporting documents you can provide may include:
          </p>
          <ul>
            <li style={{ marginTop: '0px' }}>
              Agreement or Letter of Appointment, showing the relationship, role, duties, function and reporting requirements from a third-party supplier or service provider
            </li>
            <li style={{ marginTop: '0px' }}>
              Credit card or Bank statements
            </li>
            <li style={{ marginTop: '0px' }}>
              Journal or General ledger transaction details
            </li>
            <li style={{ marginTop: '0px' }}>
              Details of remuneration (e.g., Payslips, Employment contracts)
            </li>
            <li style={{ marginTop: '0px' }}>
              Travel invoices
            </li>
            <li style={{ marginTop: '0px' }}>
              Tier 3 Grantees must also provide the largest invoice paid to their representative and/or consultant and corresponding bank statement that shows the transaction.
            </li>
          </ul>
          <p>
            Invoices (or other supporting documentation) need to be provided in English or translated (and if requested, verified by a professional translator) to English.
          </p>
        </Alert>

        <SupportingDocumentation model={model} onChange={onChange} ref={(r) => { this.supportingDocumentation = r }} history={history} preview={preview} />

        <FormItem label={(
          <span className="form-content-preview" style={{ fontSize: this.props.preview ? '10pt' : 'inherits' }}>
            <h3>Report Summary</h3>
            <ReadOnly
              label="Reporting Period"
              labelContent={model.grantAgreementDetailModel.reportingPeriod}
              layout={ReadLayout.Horizontal}
            />
            <ReadOnly
              label="Total Eligible Expenditure"
              labelContent={formatMoneyForDisplay(model.milestoneModel.totalEligibleExpenditureForAllExpenditures)}
              layout={ReadLayout.Horizontal}
            />
            <ReadOnly
              label="Total Grant Amount Sought"
              labelContent={formatMoneyForDisplay(model.milestoneModel.grantSoughtAmountForAllExpenditures)}
              layout={ReadLayout.Horizontal}
            />

            <br />
            <h3>Declaration</h3>
            <div>
              I confirm that the information in this report has been reviewed by and confirmed as correct by
              {' '}
              {model?.applicationModel?.primaryContact}
              , as the authorised person of the grantee.

              (Please note: the 'authorised person' must be the same person who accepted the EMDG agreement, or person otherwise notified to Austrade by the grantee as the authorised representative of the grantee.)

              I am authorised by the grantee to submit this report and declare:
              <ul>
                <li style={{ marginTop: '0px' }}>
                  the information in this report is accurate, complete and not misleading and that I understand the giving of false or misleading information is a serious offence under the Criminal Code 1995 (Cth).
                </li>
                <li style={{ marginTop: '0px' }}>
                  the activities undertaken and the expenditure incurred is in accordance with the Grant Agreement.
                </li>
                <li style={{ marginTop: '0px' }}>
                  I am aware (or [if not submitted by the authorised person] the authorised person of the Grantee has confirmed to me that they are aware) of the Grantee's obligations under their Grant Agreement, including survival clauses.
                </li>
                <li style={{ marginTop: '0px' }}>
                  I am aware (or [if not submitted by the authorised person] the authorised person of the Grantee has confirmed to me that they are aware) that the Grant Agreement empowers the Commonwealth to terminate the Grant Agreement and to request repayment of funds paid to the Grantee where the Grantee is in breach of the Grant Agreement.
                </li>
                <li>
                  I am aware Austrade may share the Grantee's personal information to third parties for the purpose of assessing this report and verifying payments. Personal information includes, for example, a person's name, contact details, position and any financial information regarding that person.
                </li>
                <li style={{ marginTop: '0px' }}>
                  I agree (or [if not submitted by the authorised person] I have confirmed with the authorised person of the grantee who agrees) to maintain the following records:
                  <ul>
                    <li style={{ marginTop: '0px' }}>
                        identify the receipt and expenditure of the Grant and any Other Contributions separately within the Grantee's accounts and records, so that at all times, the Grant is identifiable; and
                      </li>
                    <li style={{ marginTop: '0px' }}>
                        keep financial accounts and records relating to the Activity to enable all receipts and payments related to the Activity to be identified and reported; and
                      </li>
                    <li style={{ marginTop: '0px' }}>
                        keep records of the reports submitted in accordance with the Grant Details. G3.2 The Grantee agrees to maintain the records for five years after the Activity Completion Date and provide copies of the records to the Commonwealth representative upon request.
                      </li>
                  </ul>
                </li>
              </ul>
            </div>

          </span>
)}
        />
        <br />

        <Checkbox
          ref={(r) => { this.isDeclarationAccepted = r }}
          id="isDeclarationAccepted"
          label="By checking this box I agree to all of the above declarations and confirm all of the above statements to be true."
          value={model.milestoneModel.isDeclarationAccepted}
          onChange={(val) => onChange({ isDeclarationAccepted: val || null })}
          requiredMessage="This field is required"
          required
          preview={preview}
        />
        <br />
        <p>Please provide the details of the authorised person submitting this milestone report.</p>

        <NumericSelectField
          ref={(r) => { this.salutation = r }}
          id="applicantSalutation"
          label="Title"
          value={model.milestoneModel.authorisedTitle}
          onChange={(title) => onChange({ authorisedTitle: title })}
          dataSource={salutationDataSource}
          block={false}
          required
          preview={preview}
        />

        <TextField
          ref={(r) => { this.authorisedFirstName = r }}
          id="authorisedFirstName"
          label="Given name"
          value={model.milestoneModel.authorisedFirstName}
          onChange={(firstName) => onChange({ authorisedFirstName: firstName })}
          maxLength={50}
          required
          preview={preview}
        />

        <TextField
          ref={(r) => { this.authorisedLastName = r }}
          id="authorisedLastName"
          label="Family name"
          value={model.milestoneModel.authorisedLastName}
          onChange={(lastName) => onChange({ authorisedLastName: lastName })}
          maxLength={50}
          required
          preview={preview}
        />

        <TextField
          ref={(r) => { this.authorisedPosition = r }}
          id="applicantPosition"
          label="Position title"
          value={model.milestoneModel.authorisedPosition}
          onChange={(position) => onChange({ authorisedPosition: position })}
          maxLength={50}
          required
          preview={preview}
        />
        <br />
        <br />
        <div>After you submit your milestone report you will receive a milestone report reference number and a copy of your milestone report via email.</div>
        <div tabIndex={-1} ref={(r) => { this.submittedErrorDiv = r }} className="mt-3" style={{ display: submissionError ? '' : 'none' }}>
          <Alert className="emdg-page-alerts emdg-page-alerts--error">
            {submissionError}
          </Alert>
        </div>
        <NextBackButtons
          onBack={() => history.push(`/milestone-report/${model.milestoneModel.milestoneReportID}/expenditure`)}
          nextLabel="Submit"
          onNext={this.submit}
          preview={preview}
        />

        <Backdrop on={loading} />
        {pdfContent
          ? (
            <div ref={(r) => { this.previewContent = r }}>
              <MilestoneReportPreviewPage
                model={model}
                onChange={onChange}
                onSubmit={onSubmit}
                history={history}
              />
            </div>
          ) : <></>}
      </>
    )
  }
}
